
import React, { useEffect, useState } from "react";

import "./LocateAddressModal.css";

import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

const LocateAddressModal = ({
  active,
  locateAddressInputRef,
  callback,
  handleGeocoding,
  address,
  setAddress
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    setShow(!!active);
  }, [active]);

  useEffect(() => {
    if (callback) {
      callback(show);
    }
  }, [show, callback]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleGeocoding();
  };

  return (
    <Dialog
      className="LocateAddressDialog"
      header="Buscador de endereço"
      visible={show}
      onHide={handleClose}
      modal
      dismissableMask
      closable
      appendTo={document.body}
      draggable={false}
      resizable={false}
      blockScroll
      style={{ width: "520px" }}
    >
      <div className="LocateAddressBody">

        <div className="LocateAddressDescription">
          <i className="pi pi-info-circle" />

          <span>
            Informe as coordenadas <strong>(lat, long) em graus decimais</strong> ou digite o
            endereço completo para localizar no mapa.
          </span>
        </div>

        <form
          className="LocateAddressForm"
          onSubmit={handleSubmit}
        >
          <div className="LocateAddressInputWrapper">

            <InputText
              ref={locateAddressInputRef}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Digite o endereço que você procura..."
              className="LocateAddressInput"
            />

            <Button
              type="submit"
              icon="pi pi-search"
              className="LocateAddressSearchButton"
              onClick={handleGeocoding}
              aria-label="Buscar endereço"
            />

          </div>

          <div className="LocateAddressFeedback valid-feedback">
            <i className="pi pi-spin pi-spinner" />
            Procurando endereço...
          </div>

          <div className="LocateAddressFeedback invalid-feedback">
            <i className="pi pi-exclamation-circle" />
            Endereço não encontrado.
          </div>
        </form>

      </div>

      <div className="LocateAddressFooter">
        <Button
          severity="secondary"
          icon="pi pi-times"
          label="Fechar"
          onClick={handleClose}
          className="CloseBtn"
        />
      </div>
    </Dialog>
  );
};

export default LocateAddressModal;

